import { motion, useReducedMotion } from "framer-motion";
import { IMG, FINAL_CTA } from "@/data/content";
import { Words } from "@/lib/motion";

/**
 * Cinematic manifesto section.
 * Image is STATIC — no scroll-dependent scale, no parallax, no zoom.
 * Only a brightness reveal on viewport entry (once).
 */
export default function Manifesto() {
    const rm = useReducedMotion();

    return (
        <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-ink" data-testid="manifesto-section">
            {/* Static background — no useScroll, no scale transform */}
            <div className="absolute inset-0 z-0">
                <motion.img
                    src={IMG.manifesto}
                    alt=""
                    aria-hidden="true"
                    className="w-full h-full object-cover"
                    loading="lazy"
                    decoding="async"
                    initial={rm ? undefined : { opacity: 0.6, filter: "brightness(0.5) saturate(0.7)" }}
                    whileInView={{ opacity: 1, filter: "brightness(0.85) saturate(1)" }}
                    viewport={{ once: true, margin: "-10% 0px" }}
                    transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
                    style={{ willChange: "opacity, filter" }}
                />
            </div>
            {/* Fixed dark overlay */}
            <div className="absolute inset-0 z-[1] bg-ink/50" />
            <div className="absolute inset-0 z-[1] pointer-events-none" style={{ background: "radial-gradient(60% 60% at 50% 50%, rgba(46,123,255,0.18), transparent 70%)" }} />

            <div className="relative z-10 text-center px-6 max-w-4xl">
                <p className="text-[11px] uppercase tracking-[0.35em] text-electric-soft font-body mb-8">L&apos;exigence en mouvement</p>
                <h2 className="text-3xl sm:text-5xl lg:text-6xl font-light text-white leading-[1.12] font-display text-balance">
                    <Words text={FINAL_CTA.manifesto} />
                </h2>
                <motion.p
                    initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: 0.6, duration: 1 }}
                    className="mt-8 text-white/70 font-display italic text-lg md:text-xl"
                >
                    « {FINAL_CTA.slogan} »
                </motion.p>
            </div>
        </section>
    );
}
